import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { fallbackUrl: String };

  connect() {
    this.fallbackUrlValue = this.fallbackUrlValue || "/portal";
  }

  goBackOrHome(event) {
    event.preventDefault();

    // Try browser back first (works well with full page navigation)
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // Only fall back to home if there's no history
      Turbo.visit(this.fallbackUrlValue);
    }
  }
}
